import api from '../../utils/api';
import store from '../index';
import authStore from './auth';

const actions = {
	async polarisFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async polarisPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.post(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				// if (!store.state.userPartnerToken) {
				// 	const token = response && response.data && response.data.token ? response.data.token : null;
				// 	await commit('setUserPartnerToken', token);
				// }
				if (response.next_step.name === 'REDIRECT') {
					commit('setTransactionReference', response.data.reference);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async queryTransactionStatusApi({ commit, dispatch }, data) {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setQueryTransactionStatus', response.message);
				if (response.is_completed) {
					commit('setIsLoading', false);
					const data = Object.keys(response).includes('next_step') ? response.next_step : { ...response, name: 'SUCCESSFUL'};
					commit('setNextModal', data);
					if (response.success) {
						commit('setIframeResponseOnSuccess', {
							status: true,
							type: 'SUCCESS',
							data: {
								status: 'successful',
								data: {
									reference: store.state.transactionReference,
									redirect_url: authStore.state.payload.redirect_url
										? authStore.state.payload.redirect_url
										: false
								}
							}
						});
					} else {
						commit('setIframeResponseOnError', {
							message: response.message,
							type: 'ERROR'
						});
					}
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	actions
};
